import { withStyles } from '@material-ui/styles';
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import { CardHeader } from '../../components/CardHeader';
import { FileImportHistoryGrid } from '../../components/FileImport';
import { OrderStatusCard } from '../../components/OrderStatusCard';
// SERVICES
import { getDashboardCounts } from '../../services';

// Bringing in app version from Package.json
var { version: appVersion } = require('../../../package.json');

const styles = theme => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
  },

  orderStatusCardsContainer: {
    flexWrap: 'wrap',
  },
});

const UnderwriterDashboard = withStyles(styles)(props => {
  const { classes } = props;

  const [statusCards, setStatusCards] = useState([
    {
      status: 'In Field',
      label: 'In Field',
      count: 0,
      seq: 1,
    },
    {
      status: 'In QA',
      label: 'In QA',
      count: 0,
      seq: 2,
    },
    {
      status: 'In Progress',
      label: 'In Progress',
      count: 0,
      seq: 3,
    },
    {
      status: 'Client Closed',
      label: 'Closed',
      count: 0,
      seq: 4,
    },
  ]);

  useEffect(() => {
    const getCounts = async () => {
      try {
        const data = await getDashboardCounts('UNDERWRITER');
        setStatusCards(data.sort((a, b) => (a.seq > b.seq ? 1 : -1)));
      } catch (error) {
        console.log(error);
      }
    };

    getCounts();
  }, []);

  return (
    <div className={classnames('flex-1', classes.main)}>
      <div className={classnames('row-center-center')}>
        <div
          className={classnames('flex-1', 'status-cards', 'bg-white', 'align-stretch', 'flex-wrap')}
          style={{ background: 'none', flexDirection: 'row' }}
        >
          {statusCards.map(card => (
            <OrderStatusCard key={card.status} disabled statusInfo={card} />
          ))}
        </div>
      </div>
      <div className={classnames('row-center-center', 'bg-white')} style={{ padding: 10, fontSize: 12, color: '#aaa' }}>
        Underwriter Portal - Version {appVersion}
      </div>
    </div>
  );
});

UnderwriterDashboard.propTypes = {};

UnderwriterDashboard.defaultProps = {};

export default UnderwriterDashboard;
